import React from "react";
import Title from "../../ui/Title";

const CareMatter = () => {
  return (
    <div>
      <Title title="Why does the care economy matter?" />

      <div className="space-y-4 text-softBlack leading-loose text-base font-normal mt-4">
        <p>
          According to the ILO, strengthening the care economy is essential to:
        </p>
        <ul className="list-disc list-outside space-y-2 ml-6">
          <li>
            Advancing gender equality and inclusion, including increasing
            women’s participation in the workforce
          </li>
          <li>
            Creating conditions for decent work, including adequate
            remuneration, safe working conditions, social protection schemes,
            and gender-inclusive workplaces
          </li>
          <li>
            Providing affordable, accessible, and quality care services to all
          </li>
          <li>
            Building resilience to crises such as low labor force participation,
            pandemics, and brain drain
          </li>
          <li>
            Generating more employment opportunities for men and women in care
            work
          </li>
        </ul>
        <p>
          According to the World Economic Forum, from an economic perspective,
          this translates to:
        </p>
        <ul className="list-disc list-outside space-y-2 ml-6">
          <li>Higher levels of productivity and growth</li>
          <li>Higher business profitability and efficiency</li>
          <li>Lower long-term social expenditure</li>
        </ul>
      </div>
    </div>
  );
};

export default CareMatter;
